import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFilteredEvents } from '../actions';
import { Global_ISDA_Functions } from 'Root/global/global';

class EventPastMagazineView extends Component {
	constructor( props ) {
		super( props );
	}

	renderEvents() {
		let globalIsdaFunctions = new Global_ISDA_Functions();
		let filteredEvents = getFilteredEvents( this.props.searchTerm, this.props.regionTerm, this.props.categoryTerm, this.props.pastEvents );

		let loadedState = globalIsdaFunctions.vanillaHasClass( document.querySelector( '.react-fallback' ), 'loaded' );

		if ( Array.isArray( filteredEvents ) && filteredEvents.length && loadedState === true ) {
			return filteredEvents.map( ( event, ind ) => {
				//loaded post loop
				return (<div key={ ind }
				             className="events-post col-sm-12 col-md-6 col-lg-3"
				             data-region={ event.region }>
						<div className="events-post-wrapper">
							<div className="date-bookmark-container">
								<p className="events-post-date">{ event.formatted_date }</p>
								<div className="bookmark-container">
									<div className="bookmark">
										<i className={ `fa-bookmark ${ ISDA_Main.userBookmarks.includes( event.id )
										                               ? 'fa'
										                               : 'fa-regular' } toggle-bookmark` }
										   data-post-id={ event.id }></i>
									</div>
								</div>
							</div>
							<p className="events-post-location">
								{ event.city.name }
							</p>
							<h2 className="events-post-title">
								<span>{ event.title }</span>
							</h2>
							<div className="events-post-img-wrap">
								<img src={ event.thumbnail }
								     className="event-venue-thumbnail" alt=""
								     role="presentation" width="336"
								     height="297"/>
							</div>
						</div>
					</div>
				);
			} );
		} else if ( loadedState === true && filteredEvents.length === 0 ) {
			//when filters return no posts
			return (
				<p className="alert alert-info">No events found. Please clear
					your filters and try again.</p>
			);
		} else {
			//when posts haven't loaded yet
			return [0, 1, 2].map( ind => this.getEmptyEvent() );
		}
	}

	getEmptyEvent() {
		return (<div className="events-post col-sm-12 col-md-6 col-lg-3">
				<div className="events-post-wrapper">
				<p className="events-post-date">&nbsp;</p>
				<p className="events-post-location">&nbsp;</p>
				<h3 className="events-post-title">&nbsp;</h3>
				<div className="events-post-img-wrap">
					<a href="">
						<span className="event-venue-thumbnail placeholder"
						      width="336" height="297"/>
					</a>
				</div>
				<div className="events-post-content">
					<a href="" className="btn btn-default">
						&nbsp;
					</a>
					<a href="" className="btn btn-default">
						&nbsp;
					</a>
				</div>
				</div>
			</div>
		);
	}

	render() {
		return (<div className="events-post-list">
				{ this.renderEvents() }
			</div>
		);
	}
}

function mapStateToProps( {
	pastEvents, searchTerm, regionTerm, categoryTerm
} ) {
	return { pastEvents, searchTerm, regionTerm, categoryTerm };
}

export default connect( mapStateToProps, null )( EventPastMagazineView );
